import BankCodeInput from "./bankCodeInput";
import { formatAUCode } from "@edaz/utils/bankAccount";

export default class AuInput<TTarget> extends BankCodeInput<TTarget> {
  // AU/BSB code - A BSB code is a six-digit number used to identify the individual branch of an Australian financial institution.
  protected mask = [/[0-9]/, /[0-9]/, /[0-9]/, "-", /[0-9]/, /[0-9]/, /[0-9]/];
  protected valueFormatter = formatAUCode;
}
